import type { ClientToolsConfig } from "@elevenlabs/client";

type ClientTools = ClientToolsConfig["clientTools"];
type ClientTool = ClientTools[string];

export function buildConversationClientTools(
  gpsEnabled: boolean,
  baseTools: ClientTools,
  getCurrentLocation: ClientTool
): ClientTools {
  if (!gpsEnabled) return baseTools;
  return {
    ...baseTools,
    get_current_location: getCurrentLocation,
  };
}
